import { createFileRoute } from "@tanstack/react-router";
import RedirectSettings from "@/pages/admin/RedirectSettings";

export const Route = createFileRoute("/admin/redirect-settings")({
  component: RedirectSettings,
});
